const config={
         apiUrl:'https://apihms.cloudgentechnologies.com'      
};

export default config;